var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex description_general"},[_c('mdb-accordion',{staticClass:"accordeon",attrs:{"panes":_vm.panes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }